import * as React from 'react'
import {
  Slider as InputSlider,
  SliderProps,
  ThemeProvider,
} from '@mui/material'
import { theme } from './theme'

export function InputRangeSlider(props: SliderProps) {
  const {
    value,
    onChange,
    step = 1,
    max = 100,
    min = 0,
    ...additionalProp
  } = props

  return (
    <ThemeProvider theme={theme}>
      <InputSlider
        value={value}
        onChange={onChange}
        step={step}
        max={max}
        min={min}
        {...additionalProp}
      />
    </ThemeProvider>
  )
}
